import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewServiceComponent } from './pages/new-service/new-service.component';
import { ServicesListComponent } from './pages/services-list/services-list.component';
import { ServicesComponent } from './services.component';
import { DynamicAdditionsComponent } from './pages/dynamic-additions/dynamic-additions.component';
import { DynamicAdditionsDetailsComponent } from './pages/dynamic-additions-details/dynamic-additions-details.component';
import { ServicesSettingsComponent } from './pages/services-settings/services-settings.component';
import { WebsiteConfigrationsComponent } from './pages/website-configrations/website-configrations.component';
import { TermsConditionsListComponent } from './pages/terms-conditions-list/terms-conditions-list.component';
import { TermsConditionsDetailsComponent } from './pages/terms-conditions-details/terms-conditions-details.component';
import { ServiceSeoComponent } from './pages/service-seo/service-seo.component';
import { UserType } from 'src/app/models/enums/user-type.enum';
import { RoleGuard } from 'src/app/core/guards/role-guard/role-guard.guard';

const routes: Routes = [
  {
    path: '',
    component: ServicesComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'list' },
      { path: 'list', component: ServicesListComponent },
      { path: 'list/:sopra', component: ServicesListComponent },
      { path: 'settings/:id', component: ServicesSettingsComponent },
      { path: 'website-configuration/:id', component: WebsiteConfigrationsComponent },
      { path: 'new', component: NewServiceComponent },
      { path: 'edit/:id', component: NewServiceComponent },
      { path: 'additions', component: DynamicAdditionsComponent },
      { path: 'additions/new', component: DynamicAdditionsDetailsComponent },
      { path: 'additions/edit/:id', component: DynamicAdditionsDetailsComponent },
      { path: 'terms-conditions', component: TermsConditionsListComponent },
      { path: 'terms-conditions/:id', component: TermsConditionsDetailsComponent },
      { path: 'seo-configuration/:id', 
        component: ServiceSeoComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Markting, UserType.Admin]
        }
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ServicesRoutingModule {}
